

import './emblem.style.css'



const Emblem = ({kind, id, big, alt, noborder}) => {;
    
    const big_ext = big?'@2x':'';
    return (
        <img className={`emblem ${noborder?'noborder':''}`}
        alt={alt}
        title={alt}
        src={require('../../assets/img/resources/'+kind+'_'+id+big_ext+'.png')} 
    />
    )
}

export default Emblem